
export const graphDataLastValueConstants = {

   getGraphDataLastValueSuccess: 'GET_GRAPH_DATA_LAST_VALUE_SUCCESS',
   getGraphDataLastValueFailure: 'GET_GRAPH_DATA_LAST_VALUE_FAILURE',
};
